/**
 * Load the ressources for the app.
 */
import axios from "axios";
import { PageSource } from "./sources";
import { PageAction, LoadAction } from "./actions";

if (process.env.NODE_ENV === "development") {
  // Development axios conf
  axios.defaults.baseURL = "http://localhost:3000";
}
// Configure default for axios.
axios.defaults.timeout = false;
axios.defaults.responseType = "json";
axios.defaults.headers = { "X-Requested-With": "XMLHttpRequest" };

export default function() {
  LoadAction.addProcess();
  return PageSource.fetch().then(storeSnapshot => {
    PageAction.init(storeSnapshot);
    LoadAction.removeProcess();
    return Promise.resolve();
  });
}
